import * as React from 'react';
import { TextField, FormControl} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { ICoinlessConfig } from '../../_types/location';

interface Props {
    classes: any;
    /** the item to display */
    item: ICoinlessConfig;
    onChange: (config: any) => void;
};

// LEARN
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        }
//     home: { color: "primary" },
//     away: { color: theme.palette.grey[900] }
}));

const CoinlessConfig: React.FC<Props> = (prop: Props) => {

    const classes = useStyles();

    return (
    <Grid container direction="row" alignItems="center">
  
        <Grid item>
            <FormControl className={classes.formControl}>
                <TextField label="Equipment Id" value={prop.item.EquipmentId} onChange={(e) => {let i = prop.item; i.EquipmentId = e.target.value; prop.onChange(i)}}></TextField>
            </FormControl>
        </Grid>
    </Grid>
    );
}

export default CoinlessConfig;